import { Expose } from "class-transformer";
import { ICmsCollectionMetadataAttributes } from "./cms-collection-metadata-attributes.entity.interface";

export class CmsCollectionMetadataAttributes implements ICmsCollectionMetadataAttributes {
  @Expose()
  createdAt!: string;
  @Expose()
  publishedAt!: string;
  @Expose()
  updatedAt!: string;
}
